<template>
  <Layout>
    <template #header-container>
      <PageHeader
        isSticky
        hasBreadcrumb
        hasBackButton
        buttonText="Kembali"
        pageType="transaction"
        :title="title"
      >
        <template #afterTitle>
          <div class="d-flex align-items-center gap-2">
            <McButton
              variant="secondary"
              :icon="contentItem.iconSecondaryBtn"
              :text="contentItem.textSecondaryBtn"
              :disabled="isLoading"
              @click="handleClickSecondaryBtn"
            />
            <McButton
              variant="primary"
              :icon="contentItem.iconPrimaryBtn"
              :text="contentItem.textPrimaryBtn"
              :iconPosition="contentItem.iconPositionPrimaryBtn"
              :disabled="disablePrimaryBtn || isLoading"
              @click="handleClickPrimaryBtn"
            />
          </div>
        </template>
      </PageHeader>
    </template>

    <McWizard withNumber :activeKey="activeKey" :items="wizardItems" />

    <!-- eslint-disable-next-line vue/require-component-is -->
    <component
      :is="contentItems[activeKey].component"
      :ref="contentItems[activeKey].ref"
      :selectedIds="selectedTemplateIds"
      @update:selectedIds="handleSelectValue"
      @update:isLoading="isLoading = $event"
    />
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import { computed } from 'vue'

import Layout from '@/router/layouts/main'
import PageHeader from '@/components/page-header-v2'
import McButton from '@/components/McButton'
import McWizard from '@/components/McWizard'

import AttachTemplate from './contents/AttachTemplate'
import Scheduler from './contents/Scheduler'

import wizardItems from './lib/constants/wizard-items.js'

import * as DeliveryScheduler from '@/services/rest-api/lib/scheduler/scheduler'
import { formValuesToRruleString } from './helpers/rrule.js'

export default {
  page: {
    title: 'Delivery Scheduler',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McButton,
    McWizard,
  },
  provide() {
    return {
      isLoading: computed(() => this.isLoading),
    }
  },
  data() {
    return {
      isLoading: false,
      activeKey: 'attach-template',

      wizardItems,
      selectedTemplateIds: [],

      contentItems: {
        'attach-template': {
          ref: 'attach-template-ref',
          component: AttachTemplate,
          textPrimaryBtn: 'Selanjutnya',
          iconPrimaryBtn: 'icon-fill_arrow-right',
          textSecondaryBtn: 'Buat Template Baru',
          iconSecondaryBtn: 'icon-fill_plus',
          iconPositionPrimaryBtn: 'right',
        },
        scheduler: {
          ref: 'scheduler-ref',
          component: Scheduler,
          textPrimaryBtn: 'Simpan',
          iconPrimaryBtn: 'icon-outline_save',
          textSecondaryBtn: 'Sebelumnya',
          iconSecondaryBtn: 'icon-outline_arrow-left',
          iconPositionPrimaryBtn: 'left',
        },
      },
    }
  },
  computed: {
    title() {
      return 'Tambah Penjadwalan Baru'
    },
    contentItem() {
      return this.contentItems[this.activeKey]
    },
    disablePrimaryBtn() {
      if (this.activeKey === 'attach-template') {
        if (this.selectedTemplateIds.length === 0) {
          return true
        }
      }

      return false
    },
  },
  methods: {
    handleSelectValue(ids) {
      this.selectedTemplateIds = Object.keys(ids)
        .filter((key) => ids[key] === true)
        .map((id) => ({
          id,
        }))
    },

    handleClickSecondaryBtn() {
      if (this.activeKey === 'attach-template') {
        const routeData = this.$router.resolve({
          name: 'Setting Template Delivery Order Create',
        })

        window.open(routeData.href, '_blank').focus()
        return
      }

      this.activeKey = 'attach-template'
    },

    handleClickPrimaryBtn() {
      if (this.activeKey === 'attach-template') {
        this.activeKey = 'scheduler'

        return
      }

      const data = this.$refs['scheduler-ref'].GetFormValues()

      if (data === null) return

      this.handleSubmit(data)
    },

    async handleSubmit(data) {
      this.isLoading = true

      const recurrence = formValuesToRruleString(data)

      const res = await DeliveryScheduler.store({
        name: data.name,
        template_ids: this.selectedTemplateIds.map((item) => item.id),
        template_type: 'delivery-order',
        recurrence,
      })

      if (res.errors) {
        this.isLoading = false

        if (res.errors.templates) {
          this.$mcToast.error('Gagal disimpan. Ada kesalahan pada template.')
        } else {
          this.$refs['scheduler-ref'].AssignErrors(res.errors)
          this.$mcToast.error('Terdapat kesalahan pada input Anda')
        }

        return
      }

      this.$mcToast.success('Penjadwalan baru berhasil dibuat.')
      this.$router.push({ name: 'Delivery Scheduler' })

      this.isLoading = false
    },
  },
}
</script>
